<template>
  <div>
    <div class="tit">热点资讯</div>
    <div>
      <ul>
        <li v-for="item in list" :key="item.id">
          <router-link :to="{path: '../../news/detail',query:{id:item.id,title:item.title}}" target="_blank">
            {{item.title}}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
};
</script>
<style scoped>
.tit {
  color: rgba(0, 0, 0, 0.88);
  font-size: 16px;
  margin-bottom: 14px;
}
li {
  position: relative;
  padding-left: 12px;
  color: rgba(0, 0, 0, 0.74);
}
li a {
  color: rgba(0, 0, 0, 0.74);
  font-size: 14px;
}
li a:hover {
  text-decoration: none;
}
li::before {
  content: '';
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.74);
  top: 8px;
  left: -0px;
}
li:not(:first-child) {
  margin-top: 24px;
}
</style>
